export interface TemplateGroup {
  placeholder: string;
  text: string | null;
  rteText?: string | null;
}

export default class {
  public constructor(
    readonly template: string,
    readonly groups?: { [index: number]: TemplateGroup }
  ) {}
}
